import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable } from '../../../theme/Component/BasicTable';
import { _ExternalFactory } from '../../../../core/services/dataBean/EntityCatalogVdos';
import usePaginator from '../../../theme/Component/usePaginator';
import { BasicButton } from '../../../theme/Component/BasicButton';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const ExternalFactoryEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_ExternalFactory)
    const [id, setID] = useState(null);
    const [regexStr, setregexStr] = useState<any>(null)
    const modal = useModal("Maquila/Centro de Fabricación Externo", MODAL_LG);
    const paginador = usePaginator();

    useEffect(() => {
        getLista();
    }, [paginador.page])
    useEffect(() => {
        setID(idSelector)
    }, [idSelector])



    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDExternalFactory == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getExternalFactoryCatalog(null, null, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDExternalFactory', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Tercero', property: 'AccountName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Recurso"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-4">
                        <label>Búsqueda por Texto</label>
                        <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                            Buscar
                        </BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDExternalFactory); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
            </Modal>
        </>
    )
}